import React from 'react';
import { useElement, useProjectState } from '@starflow/app/store';
import { UpscalePanel as LegacyUpscalePanel } from './_legacy';

export { wrapImageOverlayer } from './Overlayer';

const UpscalePanelInner = React.memo(({ elementId, nodeId }) => {
  const element = useElement(elementId);
  const node = useProjectState((state) => state.nodeMap[nodeId]);

  if (!node) return null;
  return <LegacyUpscalePanel generator={node.data} element={element} />;
});

export const UpscalePanel = () => {
  const currentNodeId = useProjectState('currentNodeId');
  const elementId = useProjectState('editingElementId');
  if (!currentNodeId || !elementId) return null;

  const nodeType = currentNodeId.split('-')[1];

  if (nodeType !== 'upscale') return null;

  return <UpscalePanelInner nodeId={currentNodeId} elementId={elementId} />;
};
